import { useSyncExternalStore } from 'react';

import {
  isAdDownloadInFlight,
  subscribeToAdDownloadsInFlight,
} from '../api/downloadAnalyticalDatasetExport';

/**
 * Whether an export download for this profile is currently in flight — true even
 * after the download modal is closed (the fetch keeps running in the background).
 * Drives the Download button's disabled state + tooltip.
 */
export const useAdDownloadInFlight = (
  projectId: string,
  analyticalDatasetProfileId: string
): boolean =>
  useSyncExternalStore(subscribeToAdDownloadsInFlight, () =>
    isAdDownloadInFlight({ projectId, analyticalDatasetProfileId })
  );
